
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.657 7.757L13.415 12l4.242 4.243-1.414 1.414-4.242-4.243-4.243 4.243-1.414-1.414L10.586 12 6.344 7.757l1.414-1.414 4.243 4.243 4.242-4.243 1.415 1.414z","fill":"#fff"}})])
          )
        }
      }
    